/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Surcharge/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CardFeeInput from './CardFeeInput/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Surcharge({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/FeeMode/Surcharge"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<CardFeeInput
  viewPath={`${viewPath}/CardFeeInput`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 text="Add a percentage to credit card payments only (debit & ACH excluded). Insurance payor accounts excluded."
/>
{children}
</React.Fragment>)
}